var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { windowExist } from 'src/shared/constants';
import { valueExist } from 'src/shared/helpers/objHelpers';
export var buildQueryParams = function (queryParamObj) {
    var queryString = Object.entries(queryParamObj)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join('&');
    return "?".concat(queryString);
};
export var queriesParamsToObj = function (url) {
    if (!url) {
        return {};
    }
    var _a = url.split('?'), path = _a[0], queriesString = _a[1];
    if (queriesString) {
        var queries = queriesString.split('&');
        return queries.reduce(function (acc, query) {
            var _a;
            var _b = query.split('='), key = _b[0], value = _b[1];
            return __assign(__assign({}, acc), (_a = {}, _a[key] = value, _a));
        }, {});
    }
    else {
        return {};
    }
};
export var getURLQueries = function () {
    if (windowExist) {
        var urlTemplate = window.history.state.url;
        var urlPath = window.history.state.as;
        var templateParts = urlTemplate.split('/');
        var pathPart_1 = urlPath.split('/');
        var queryInUrlRegex_1 = /\[[a-zA-Z]+]/;
        var urlParsed = templateParts.reduce(function (acc, curr, index) {
            var _a;
            if (valueExist(curr) && curr.match(queryInUrlRegex_1)) {
                var queryValue = curr.slice(1, curr.length - 1);
                return __assign(__assign({}, acc), (_a = {}, _a[queryValue] = pathPart_1[index], _a));
            }
            return acc;
        }, {});
        return {
            urlInQueries: urlParsed,
        };
    }
    return {
        urlInQueries: {},
    };
};
export var changeQueryParams = function (queryParamObj) {
    var queryParamString = buildQueryParams(queryParamObj);
    if (window) {
        window.history.replaceState(null, null, queryParamString);
    }
};
export var E_URL_SCHEME;
(function (E_URL_SCHEME) {
    E_URL_SCHEME[E_URL_SCHEME["LOCAL"] = 0] = "LOCAL";
    E_URL_SCHEME[E_URL_SCHEME["QPC"] = 1] = "QPC";
    E_URL_SCHEME[E_URL_SCHEME["GCP_MIDDLE"] = 2] = "GCP_MIDDLE";
    E_URL_SCHEME[E_URL_SCHEME["GCP"] = 3] = "GCP";
})(E_URL_SCHEME || (E_URL_SCHEME = {}));
export var E_HOST;
(function (E_HOST) {
    E_HOST[E_HOST["LOCAL"] = 0] = "LOCAL";
    E_HOST[E_HOST["QPC"] = 1] = "QPC";
    E_HOST[E_HOST["GCP"] = 2] = "GCP";
})(E_HOST || (E_HOST = {}));
export var E_ENV;
(function (E_ENV) {
    E_ENV["LOCAL"] = "local";
    E_ENV["DEV"] = "dev";
    E_ENV["QA"] = "qa";
    E_ENV["PROD"] = "prod";
})(E_ENV || (E_ENV = {}));
export var parseUrl = function (domain, pathName) {
    var _a, _b, _c, _d, _e, _f;
    var defaultResponse = {
        urlScheme: E_URL_SCHEME.LOCAL,
        realm: 'quicksign',
        host: E_HOST.QPC,
        env: E_ENV.DEV,
        basePath: '',
        path: '',
    };
    if (!domain || !pathName) {
        return defaultResponse;
    }
    var localRegex = /localhost:/;
    var qpcRegex = /[a-z]+\.quicksign\.com/;
    var gcpMiddleRegex = /middle(-[a-z0-9]+)?.[a-z]+.quicksign.io/;
    var gcpRegex = /[a-z0-9]+.[a-z]+.quicksign.io/;
    var qpcProdRegex = /quicksign\.com/;
    var basePathRegex = /(\/mo\/[a-z0-9-]+)/;
    var isLocal = domain.search(localRegex) !== -1;
    var isQPC = domain.search(qpcRegex) !== -1;
    var isGCPMiddle = domain.search(gcpMiddleRegex) !== -1;
    var isGCP = domain.search(gcpRegex) !== -1;
    var isQPCProd = domain.search(qpcProdRegex) !== -1;
    if (isLocal) {
        var basePath = ((_a = pathName.match(basePathRegex)) === null || _a === void 0 ? void 0 : _a.at(0)) || '';
        var realm = basePath
            ? pathName
                .substring(basePath.length)
                .split('/')
                .find(function (el) { return !!el; })
            : pathName.split('/').find(function (el) { return !!el; });
        return {
            urlScheme: E_URL_SCHEME.LOCAL,
            realm: realm,
            host: windowExist ? (((_b = window === null || window === void 0 ? void 0 : window.env) === null || _b === void 0 ? void 0 : _b.HOST) === 'QPC' ? E_HOST.QPC : E_HOST.GCP) : E_HOST.LOCAL,
            env: windowExist ? (((_c = window === null || window === void 0 ? void 0 : window.env) === null || _c === void 0 ? void 0 : _c.ENV) === 'dev' ? E_ENV.DEV : E_ENV.QA) : E_ENV.LOCAL,
            basePath: basePath,
            path: pathName,
        };
    }
    else if (isQPC) {
        var env = domain.split('.')[0];
        var basePath = ((_d = pathName.match(basePathRegex)) === null || _d === void 0 ? void 0 : _d.at(0)) || '';
        if (basePath) {
            var pathMinusBase = pathName.slice(basePath.length);
            var realm_1 = pathMinusBase.split('/').find(function (el) { return !!el; });
            return {
                urlScheme: E_URL_SCHEME.QPC,
                realm: realm_1,
                host: E_HOST.QPC,
                env: env,
                basePath: basePath,
                path: pathMinusBase,
            };
        }
        var realm = pathName.split('/').find(function (el) { return !!el; });
        return {
            urlScheme: E_URL_SCHEME.QPC,
            realm: realm,
            host: E_HOST.QPC,
            env: env,
            basePath: '',
            path: pathName,
        };
    }
    else if (isGCPMiddle) {
        var basePath = ((_e = pathName.match(basePathRegex)) === null || _e === void 0 ? void 0 : _e.at(0)) || '';
        var env = domain.split('.').at(1);
        var realm = basePath
            ? pathName
                .substring(basePath.length)
                .split('/')
                .find(function (el) { return !!el; })
            : pathName.split('/').find(function (el) { return !!el; });
        return {
            urlScheme: E_URL_SCHEME.GCP_MIDDLE,
            realm: realm,
            host: E_HOST.GCP,
            env: env,
            basePath: basePath,
            path: pathName,
        };
    }
    else if (isGCP) {
        var _g = domain.split('.'), realm = _g[0], env = _g[1];
        var isProdEnv = env === 'platform'; // Special case for prod
        return {
            urlScheme: E_URL_SCHEME.GCP,
            realm: realm,
            host: E_HOST.GCP,
            env: isProdEnv ? E_ENV.PROD : env,
            basePath: '',
            path: pathName,
        };
    }
    else if (isQPCProd) {
        var basePath = ((_f = pathName.match(basePathRegex)) === null || _f === void 0 ? void 0 : _f.at(0)) || '';
        var pathMinusBase = pathName.slice(basePath.length);
        var realm = pathMinusBase.split('/').find(function (el) { return !!el; });
        return {
            urlScheme: E_URL_SCHEME.QPC,
            realm: realm,
            host: E_HOST.QPC,
            env: E_ENV.PROD,
            basePath: basePath,
            path: pathMinusBase,
        };
    }
    return defaultResponse;
};
